export default "__VITE_ASSET__Bex562ff__"